import { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { clearStorage, useReportWrapper, useStoreWrapper } from "../../store/store";
import { HideOnDesktop } from "../incidentLayout/incident.style";
import { AiOutlineClose } from "react-icons/ai";
import { LuChevronFirst, LuChevronLast } from "react-icons/lu";
import { BsFillQuestionSquareFill } from "react-icons/bs";

import {
  CloseIcon,
  Logo,
  LogoContainer,
  LogoIcon,
  LogoIconContainer,
  LogoText,
  ReportIncidentBtn,
  ReportIncidentBtnContainer,
  ReportIncidentBtnIcon,
  SecondMenuListItem,
  ThirdMenuContainer,
} from "./AdminLayout.style";
import AppVersion from "../../components/AppVersion/AppVersion";
import light_mg_logo from "../../assets/images/mG_logo_light.svg";
import gener8logo from "../../assets/images/gener8_logo-02.png";
import add_icon from "../../assets/images/add_icon.svg";
import homeLogo from "../../assets/images/home.png";
import chartBar from "../../assets/images/chart-bar.png";
import chartSquareBar from "../../assets/images/chart-square-bar.png";
import userLogo from "../../assets/images/users.png";
import settingsLogo from "../../assets/images/cog.png";
import { MdSupportAgent } from "react-icons/md";
import logoutLogo from "../../assets/images/logout.png";
import { usePermissionCheck } from "../../hooks/userPermissionCheck";
import { PERMISSION_LIST } from "../../shared/sharedConstants";
import styled from "styled-components";

interface ContainerProps {
  isCollapsed: boolean;
}
const CollabpseBtnContainer = styled.div<ContainerProps>`
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem;
  width: 100%;
  height: 3rem;
  cursor: pointer;
  color: white;
  font-size: 2rem;
  transition: all 0.3s;
  margin-bottom: 1rem;
  @media screen and (max-width: 901px) {
    display: none;
  }
`;
const CollapseBtn = styled.i`
  cursor: pointer;
  color: white;
  font-size: 2rem;
`;

// const List = styled.li`
//   list-style: none;
// `;
const LogoutBtn = styled.button`
  background: none;
  outline: none;
  border: none;
  color: white;
`;
interface SideBarProps {
  expanded?: boolean;
  showContent?: boolean;
}
const LogoutBtnContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const SContainer = styled.aside<SideBarProps>`
  background: #3d0052;
  display: flex;
  min-height: 100vh;
  height: 100%;
  flex-direction: column;

  font-family: Plus Jakarta Sans;
  @media screen and (max-width: 1300px) and (min-width: 769px) {
  }
  @media screen and (max-width: 901px) {
    padding-top: 20px;
  }
  z-index: 3000;
  /* overflow-y: scroll; */
  padding-bottom: 20px;
`;

const AddBtnIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
interface SpanProps {
  expanded: boolean;
}
const StyledSpan = styled.span.attrs({})<SpanProps>`
  @media screen and (min-width: 768px) {
    width: ${(props) => (props.expanded ? "15rem ml-3" : "0")};
    margin-left: ${(props) => (props.expanded ? "0.75rem" : "0")};
  }
  width: 15rem;
`;
const Divider = styled.div`
  background-color: #4b4b4b;
  background-color: whitesmoke;
  /* margin: auto 0; */
  width: 40px;
  height: 3px;
`;

const CloseIconContainer = styled.div`
  display: none;

  @media screen and (max-width: 901px) {
    display: flex;
    justify-content: flex-end;
  }
`;
const SidebarItem = ({
  icon,
  iconComponent,
  text,
  navDirection,
  onSelectItem,
  styles,
  expanded,
  testId,
}: any) => {
  return (
    // <List>
    <NavLink
      data-testid={testId}
      onClick={onSelectItem}
      className={`styleLink group relative z-10 my-1 flex cursor-pointer items-center rounded-md font-medium transition-colors ${(isActive: any) => (isActive ? "text-white bg-purple-600" : "hover:text-white text-gray-300 hover:bg-purple-600")}`}
      style={styles}
      to={navDirection}
    >
      {iconComponent || <LogoIcon src={icon} alt="icon" />}
      <StyledSpan
        expanded={expanded}
        className={`0.3s ease overflow-hidden transition-all`}
      >
        {text}
        {!expanded && (
          <div
            className={`text-white invisible absolute left-full ml-2 -translate-x-3 rounded-md bg-purple-400 px-2 py-2 text-sm opacity-20 transition-all group-hover:visible group-hover:translate-x-0 group-hover:opacity-100 ${expanded ? "" : "top-2"}`}
          >
            {text}
          </div>
        )}
      </StyledSpan>
    </NavLink>
    // </List>
  );
};

const SideBarContent = ({
  onOpenIncidentModal,
  onSelectItem,
  onSideBarItemClick,
  onSetExpanded,
  expanded,
  showContent,
}: any) => {
  const navigate = useNavigate();
  const [allowCreateIncident, setAllowCreateIncident] = useState(false);

  const { userFacilities } = useStoreWrapper((state) => ({
    userFacilities: state.userFacilities,
  }));

  usePermissionCheck(
    PERMISSION_LIST.CREATE_INCIDENT,
    userFacilities,
    setAllowCreateIncident
  );

  const navLinkStyles = ({ isActive }: any) => {
    return {
      background: isActive ? "#b580ff" : "none",
    };
  };

  const logOut = () => {
    clearStorage();
    useReportWrapper.destroy();
    localStorage.clear();
    navigate("/");
  };

  const handleSelectItem = () => {
    if (onSelectItem) onSelectItem();
    if (onSideBarItemClick) onSideBarItemClick();
  };

  const handleNavigateLogo = () => {
    if (onSideBarItemClick) onSideBarItemClick();
    navigate("/user/dashboard");
  };

  const handleReportIncident = () => {
    if (!allowCreateIncident) return;
    if (onOpenIncidentModal) onOpenIncidentModal();
    if (onSideBarItemClick) onSideBarItemClick();
  };

  return (
    <SContainer showContent data-testid="sidebar-container">
      <CollabpseBtnContainer isCollapsed={expanded}>
        <CollapseBtn onClick={onSetExpanded}>
          {expanded ? <LuChevronFirst /> : <LuChevronLast />}
        </CollapseBtn>
      </CollabpseBtnContainer>
      <CloseIconContainer>
        <AiOutlineClose
          onClick={handleSelectItem}
          color="white"
          className="ml-7 mt-3 cursor-pointer"
          size={25}
        />
      </CloseIconContainer>

      <LogoContainer>
        <LogoIconContainer onClick={handleNavigateLogo}>
          <Link to={"/"} style={{ display: "flex" }}>
            <Logo src={light_mg_logo} />
            <LogoText
              style={{ width: "7rem" }}
              src={gener8logo}
              onClick={handleNavigateLogo}
              className={`overflow-hidden transition-all ${expanded ? "w-53 ml-3" : "w-0"}`}
            />
          </Link>

          <HideOnDesktop></HideOnDesktop>
        </LogoIconContainer>
        <CloseIcon></CloseIcon>
      </LogoContainer>
      <ReportIncidentBtnContainer onClick={handleReportIncident}>
        <>
          <AddBtnIcon>
            {!expanded && <ReportIncidentBtnIcon src={add_icon} />}
          </AddBtnIcon>
          <ReportIncidentBtn
            className={`0.3s ease overflow-hidden transition-all ${expanded ? "ml-3 w-60" : "hidden w-0"}`}
          >
            <ReportIncidentBtnIcon src={add_icon} />
            <span>Report Incident</span>
          </ReportIncidentBtn>
        </>
      </ReportIncidentBtnContainer>
      <SidebarItem
        expanded={expanded}
        onSelectItem={handleSelectItem}
        styles={navLinkStyles}
        icon={homeLogo}
        text={"Dashboard"}
        navDirection="/user/dashboard"
      />
      <SidebarItem
        testId="incidents-nav-link"
        expanded={expanded}
        onSelectItem={handleSelectItem}
        styles={navLinkStyles}
        icon={chartBar}
        text={"Incidents"}
        navDirection="/user/incidents-list"
      />
      <SidebarItem
        testId="analytics-nav-link"
        expanded={expanded}
        onSelectItem={handleSelectItem}
        styles={navLinkStyles}
        icon={chartSquareBar}
        text={"Analytics"}
        navDirection="/user/analytics"
      />
      <SidebarItem
        testId="users-nav-link"
        expanded={expanded}
        onSelectItem={handleSelectItem}
        styles={navLinkStyles}
        icon={userLogo}
        text={"Users"}
        navDirection="/user/users"
      />
      <SecondMenuListItem>
        {expanded ? "SUPPORT" : <Divider />}
      </SecondMenuListItem>

      <SidebarItem
        testId="help-nav-link"
        expanded={expanded}
        onSelectItem={handleSelectItem}
        styles={navLinkStyles}
        iconComponent={
          <BsFillQuestionSquareFill style={{ marginRight: "1.2rem " }} />
        }
        text={"Help"}
        navDirection="/user/help"
      />
      <SidebarItem
        expanded={expanded}
        onSelectItem={handleSelectItem}
        styles={navLinkStyles}
        iconComponent={<MdSupportAgent style={{ marginRight: "1.2rem " }} />}
        text={"Support"}
        navDirection="/user/support"
      />
      <ThirdMenuContainer />
      <SidebarItem
        expanded={expanded}
        onSelectItem={handleSelectItem}
        styles={navLinkStyles}
        icon={settingsLogo}
        text={"Settings"}
        navDirection="/user/settings"
      />

      <LogoutBtnContainer
        className={`styleLink relative z-10 my-1 flex cursor-pointer items-center rounded-md font-medium`}
        data-testid="logout-btn"
      >
        <LogoIcon
          src={logoutLogo}
          alt="logout logo"
          className="cursor-pointer"
          onClick={logOut}
        />
        <LogoutBtn
          onClick={logOut}
          className={`cursor-pointer overflow-hidden transition-all ${expanded ? "w-53 ml-1" : "hidden w-0"}`}
        >
          Logout
        </LogoutBtn>
      </LogoutBtnContainer>

      {/* Version Display */}
      <div
        className={`flex items-center justify-center py-2 ${expanded ? "" : "px-2"}`}
      >
        <AppVersion
          className={`text-xs text-gray-400 ${expanded ? "" : "hidden"}`}
          showTooltip={!expanded}
        />
      </div>
    </SContainer>
  );
};

export default SideBarContent;
